

import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import BookingForm from "./BookForm"; // Import the form component
import Arizona from "./assets/destination/Arizona.jpg";
import California from "./assets/destination/california.jpeg";
import Colorado from "./assets/destination/Colorado.jpg";
import Florida from "./assets/destination/Florida.jpg";
import Floridaa from "./assets/destination/Florida.webp";
import illinois from "./assets/destination/illinois.jpg";
import Newyork from "./assets/destination/NewYork.jpg";
import Texas from "./assets/destination/Texas.jpeg";
import Washington from "./assets/destination/Washington.jpg";

const destinations = [
  { state: "California", city: "Los Angeles", price: "$320", img: California },
  { state: "New York", city: "New York City", price: "$450", img: Newyork },
  { state: "Texas", city: "Dallas", price: "$380", img: Texas },
  { state: "Florida", city: "Miami", price: "$290", img: Florida },
  { state: "Illinois", city: "Chicago", price: "$410", img: illinois },
  { state: "Nevada", city: "Las Vegas", price: "$399", img: Floridaa },
  { state: "Washington", city: "Seattle", price: "$430", img: Washington },
  { state: "Arizona", city: "Phoenix", price: "$370", img: Arizona },
  { state: "Colorado", city: "Denver", price: "$385", img: Colorado },
];

const FlightDestinations = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section style={{ backgroundColor: "#f0f3f5" }}>
        <div className="container my-4">
          <h2 className="text-center fw-bold my-4 text-primary">
            ✈️ Most Popular Trip Destinations in the USA
          </h2>

          {/* Destination Cards */}
          <div className="row g-4 mt-4">
            {destinations.map((dest, index) => (
              <div key={index} className="col-md-4 col-sm-6">
                <div className="card border-0 shadow-sm destination-card">
                  <div className="image-container">
                    <img
                      src={dest.img}
                      className="card-img-top"
                      alt={dest.city}
                      style={{ height: "160px", objectFit: "cover" }}
                    />
                  </div>
                  <div className="card-body ">
                    {/* Row with Two Columns */}
                    <div className="row">
                      {/* Location Section */}
                      <div className="col-12 col-md-6 card-sec">
                        <span class="text-success state"><i class="bi bi-geo-alt"></i> {dest.state}</span>
                        <h6 class="card-title fw-bold">{dest.city}</h6>
                        <p class="card-text text-muted">Economy, round trip</p>
                      </div>

                      {/* Button Section */}
                      <div className="col-12 col-md-6 mb-3">
                        <button
                          className="btn btn-warning w-100 mt-2 fw-bold book-btn"
                          onClick={() => setShowModal(true)}
                        >
                          Book Now
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Bootstrap Modal for Booking Form */}
          {showModal && (
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()} // Prevent closing on modal click
              >
                <button className="close-button" onClick={() => setShowModal(false)}>
                  ×
                </button>
                <BookingForm onClose={() => setShowModal(false)} />
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default FlightDestinations;
